export const dashboardFilters = [
  {
    filterName: "Most Recent",
  },
  {
    filterName: "Team",
  },
  {
    filterName: "Type",
  },
];

export const VALID_DASHBOARD_ROLES = [
  "Admin",
  "Department Leader",
  "Team Leader / Team Member",
  "Team Member",
] as const;

export const TrackedQuickActionEventsMapByRole = {
  Admin: "adminQuickActionClosed",
  "Department Leader": "departmentLeaderQuickActionClosed",
  "Team Leader / Team Member": "teamLeaderQuickActionClosed",
} as const;

export const OVERALL_ACTIVITY_TIME_RANGE_OPTIONS: Record<string, string> = {
  "Past 30 days": "pastMonth",
  "Past 90 days": "past90Days",
  "Past 365 days": "pastYear",
};

export const INDIVIDUAL_LOGIN_COUNT_START_DATE = "2025-03-27";

export const PAGE_VIEW_COUNT_START_DATE = "2025-06-02 05:30:19";

export const EMAIL_TYPE_TO_LABEL_MAP: Record<string, string> = {
  checkIn: "Check-In",
  teamLeaderReport: "Team Leader",
  reminder: "Check-In Reminder",
  seniorManagerReport: "Senior Manager",
  executiveReport: "Executive Intelligence",
};
